import { showSuccessMessage } from "../../../../utils";

export const notifySavedChange = () => showSuccessMessage("Change saved");
